import {Databases, Query} from "appwrite";
import {client, database_id} from "../lib/appwrite";
import {v4 as uuidv4} from "uuid";
import {EmployeeItem} from "../types/employee";

const EMPLOYEE_COLLECTION = "67b9acf20003c96477d0"
const databases = new Databases(client);

export const employeeService = {

  async list(queries: string[] = [], limit: number = 100): Promise<EmployeeItem[]> {
    try {
      const response = await databases.listDocuments(
        database_id,
        EMPLOYEE_COLLECTION,
        [
          Query.limit(limit),
          ...queries
        ]
      );
      return response.documents.map(doc => doc as unknown as EmployeeItem);

    } catch (error) {
      // console.error('Error listing news:', error);
      throw error;
    }
  },


  async createEmployee(data: EmployeeItem): Promise<EmployeeItem> {
    try {
      const createdItem = await databases.createDocument(
        database_id,
        EMPLOYEE_COLLECTION,
        uuidv4(),
        data
      ) as unknown as EmployeeItem;

      return createdItem;
    } catch (error) {
      // console.error('Помилка створення:', error); // change
      throw error;
    }
  },

  async updateEmployee(data: EmployeeItem): Promise<EmployeeItem> {
    try {
      const id = data.$id as string
      const {$id, ...correctData} = data
      const updatedItem = await databases.updateDocument(
        database_id,
        EMPLOYEE_COLLECTION,
        id,
        correctData
      ) as unknown as EmployeeItem;

      return updatedItem;
    } catch (error) {
      console.log(error)
      console.error('Помилка оновлення!', error);
      throw error;
    }
  },

  async delete(id: string): Promise<void> {
    try {
      await databases.deleteDocument(
        database_id,
        EMPLOYEE_COLLECTION,
        id
      );
    } catch (error) {
      // console.error('Error deleting news:', error);
      throw error;
    }
  },

  async getById(id: string): Promise<EmployeeItem> {
    try {
      const employeeData = await databases.getDocument(
        database_id,
        EMPLOYEE_COLLECTION,
        id
      ) as unknown as EmployeeItem;
      return employeeData
    } catch (error) {
      console.error(error)
      throw error;
    }
  }
}